import { API_CONFIG, getPangoUrl, getPangoHeaders } from '../config/api';
import { PromotionsResponse, TrendingProductsResponse, Promotion, TrendingProduct } from '../types/promotion';

class PromotionApiService {
  /**
   * Get all promotions
   */
  async getPromotions(): Promise<PromotionsResponse> {
    try {
      const endpoint = API_CONFIG.PANGO.ENDPOINTS.PROMOTIONS.GET_PROMOTIONS;
      const url = getPangoUrl(endpoint);
      
      const response = await fetch(url, {
        method: 'GET',
        headers: getPangoHeaders(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get trending products
   */
  async getTrendingProducts(): Promise<TrendingProductsResponse> {
    try {
      const endpoint = API_CONFIG.PANGO.ENDPOINTS.PROMOTIONS.GET_TRENDING_PRODUCTS;
      const url = getPangoUrl(endpoint);
      
      const response = await fetch(url, {
        method: 'GET',
        headers: getPangoHeaders(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get active promotions only
   */
  async getActivePromotions(): Promise<Promotion[]> {
    try {
      const response = await this.getPromotions();
      if (response.success && response.data) {
        return response.data.filter(promotion => promotion.active);
      }
      return [];
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get promotions count for Welcome page stats
   */
  async getPromotionsCount(): Promise<number> {
    try {
      const activePromotions = await this.getActivePromotions();
      return activePromotions.length;
    } catch (error) {
      return 0;
    }
  }

  /**
   * Get top trending products (limit by count)
   */
  async getTopTrendingProducts(limit: number = 5): Promise<TrendingProduct[]> {
    try {
      const response = await this.getTrendingProducts();
      if (response.success && response.data) {
        return response.data.slice(0, limit);
      }
      return [];
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get promotions by discount type
   */
  async getPromotionsByType(discountType: string): Promise<Promotion[]> {
    try {
      const response = await this.getPromotions();
      if (response.success && response.data) {
        return response.data.filter(promotion => 
          promotion.discount_type === discountType && promotion.active
        );
      }
      return [];
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get trending products by brand tier
   */
  async getTrendingProductsByTier(brandTier: string): Promise<TrendingProduct[]> {
    try {
      const response = await this.getTrendingProducts();
      if (response.success && response.data) {
        return response.data.filter(product => product.brand_tier === brandTier);
      }
      return [];
    } catch (error) {
      throw error;
    }
  }
}

export const promotionApi = new PromotionApiService();
